var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('explorer-layout',{attrs:{"header":"Bestellungen"},scopedSlots:_vm._u([{key:"select",fn:function(ref){
var explorerSelect = ref.explorerSelect;
return [_c('order-list',{on:{"select":function($event){(_vm.selectedOrder = $event) && explorerSelect('Bestellung ' + $event.number)}}})]}},{key:"work",fn:function(){return [_c('order-detail',{attrs:{"order":_vm.selectedOrder}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }